import type { Planet } from '@kaeliux/shared';
import { normalizePlanet as normalizePlanetDates } from '@kaeliux/shared';
import { backfillPlanetPlotIds } from '@kaeliux/game-engine';

/**
 * A raw planet payload → the engine-ready `Planet` every client store holds:
 * the date normalization shared with the mock services and the Cloud
 * Functions (`@kaeliux/shared`'s `normalizePlanet`), plus the plot-id
 * backfill. Every real service that hands a planet to a store goes through
 * here.
 *
 * A planet whose buildings predate plotId tracking (DS-28) still needs to
 * render every building somewhere stable — the server backfills and persists
 * an assignment on its next mutating request, but a planet read before that
 * happens must not wait for one. Deterministic, so this recomputes to the
 * exact same result the server will persist.
 *
 * Kept out of `planet.service.ts` on purpose: mock mode aliases that module
 * to `services/mock/planet.service`, which has no normalizer to offer.
 */
export function normalizePlanet(raw: unknown, planetId: string): Planet {
    return backfillPlanetPlotIds(normalizePlanetDates(raw, planetId));
}
